import styled, { css } from "styled-components";

interface Props {
  detailsTab?: string;
  activeTab?: Boolean;
  isShareBtn?: boolean;
  isSettingBtn?: boolean;
}
// Tabs
export const Tab = styled.button<Props>`
  font-size: 20px;
  padding: 10px 30px;
  cursor: pointer;
  opacity: 0.6;
  color: black;
  background: transparent;
  border: 0;
  outline: 0;

  ${({ activeTab }) =>
    activeTab &&
    `
    border-bottom: 2px solid #D35400;
    opacity: 1;
  `}
`;
export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  background: transparent;

  color: black;

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

export const UserProfileBtn = styled.button<Props>`
  ${(p) =>
    p.isShareBtn &&
    css`
      border: none;
      padding: 0.2rem 0.5rem;
      background: transparent;

      border: 1px solid rgb(229, 232, 235);
      border-right: none;
      border-radius: 7px 0 0 7px;
    `}

  ${(p) =>
    p.isSettingBtn &&
    css`
      border: none;
      padding: 0.2rem 0.5rem;
      background: transparent;

      border: 1px solid rgb(229, 232, 235);
      margin-left: -2rem;
      border-radius: 0px 7px 7px 0px;
    `}
`;

export const ProfileWrapper = styled.div`
  .noOffer {
    margin-bottom: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    font-weight: 500;
    font-size: 1.3rem;
    color: white;
  }
`;

export const CardRowMain = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.7rem;
  margin-top: 2rem;

  .flex-item {
    margin-left: 1rem;
  }
`;

export const NotFoundMain = styled.div`
  display: flex;
  justify-content: center;
  .noOfferDiv {
    width: 800px;
    height: 200px;
    background: orange;
    border: 1px solid #e67e22;
    border-radius: 20px;
  }

  @media (max-width: 1024px) {
    .noOfferDiv {
      width: 600px;
    }
  }
  @media (max-width: 990px) {
    .noOfferDiv {
      width: 680px;
    }
  }

  @media (max-width: 767px) {
    .noOfferDiv {
      width: 550px;
    }
  }

  @media (max-width: 567px) {
    .noOfferDiv {
      width: 480px;
    }
  }
  @media (max-width: 460px) {
    .noOfferDiv {
      width: 420px;
    }
  }
  @media (max-width: 440px) {
    .noOfferDiv {
      width: 400px;
    }
  }
  @media (max-width: 420px) {
    .noOfferDiv {
      width: 380px;
    }
  }
  @media (max-width: 400px) {
    .noOfferDiv {
      width: 360px;
    }
  }
  @media (max-width: 375px) {
    .noOfferDiv {
      width: 330px;
    }
  }
  @media (max-width: 350px) {
    .noOfferDiv {
      width: 310px;
    }
  }
  @media (max-width: 350px) {
    .noOfferDiv {
      width: 300px;
    }
  }
`;
